

export type RouteKeys = 'wms-job' | 'task' | 'fulfillment' | 'sales_orders' | 'outbound-shipment' | 'cycle_count' | 'work-order' | 'purchase-order' | 'asn' | 'stock_transfer' | 'inventory_adjustment' | 'kit_order';


export function getRouteUrl(key: RouteKeys): string | undefined {
  const urls: Record<RouteKeys, string> = {
    'wms-job': '/operations/jobs/detail',
    'task': '/operations/tasks/detail',
    'fulfillment': '/fulfillment/fulfillment-requests/detail',
    'sales_orders': '/outbound/sales-orders/detail',
    'outbound-shipment': '/outbound/outbound-shipment/detail',
    'cycle_count': '/inventory/cycle-counts/detail',
    'work-order': '/kitting/kit-orders/detail',
    'purchase-order': '/inbound/purchase-order/detail',
    'asn': '/inbound/asn/detail',
    'stock_transfer': '/inventory/stock-transfer/detail',
    'inventory_adjustment': '/inventory/inventory-adjustments/detail',
    'kit_order': '/kitting/kit-orders/detail'
  };

  return urls[key];
}
